// src/viewmodel/signal-adapter.ts
import { createSignal } from "solid-js";
function createSolidSignalAdapter() {
  return {
    createGetter(subscribable) {
      const [get, set] = createSignal(subscribable.value);
      subscribable.subscribe(() => set(() => subscribable.value));
      return get;
    },
    createWritable(initial) {
      return createSignal(initial);
    }
  };
}

// src/viewmodel/factory.ts
import { createViewModelFactory } from "@wovin/core/viewmodel";
function createSolidViewModel(options) {
  return createViewModelFactory({
    ...options,
    signalAdapter: createSolidSignalAdapter()
  });
}

// src/viewmodel/useVM.ts
import { createMemo } from "solid-js";
function useVM(vmClass, en, thread) {
  return createMemo(() => {
    const id = typeof en === "function" ? en() : en;
    if (!id) return null;
    return vmClass.get(id, thread);
  });
}
function useCreateVM(vmClass, init, thread) {
  const builder = vmClass.buildNew(init);
  if (!builder.en) throw new Error("[useCreateVM] builder has no en \u2014 ensure buildNew generates one");
  return createMemo(() => {
    return vmClass.get(builder.en, thread);
  });
}
export {
  createSolidSignalAdapter,
  createSolidViewModel,
  useCreateVM,
  useVM
};
//# sourceMappingURL=index.js.map